var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary mt-5 px-5",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }